import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['checkbox', 'warning'];
  static values = {
    triggerValues: Array
  };

  connect() {
    this.updateWarningVisibility();
  }

  toggle(event) {
    this.updateWarningVisibility();
  }

  updateWarningVisibility() {
    if (!this.hasWarningTarget) return;

    const hasTriggerCondition = this.checkboxTargets.some((checkbox) => {
      return checkbox.checked && this.triggerValuesValue.includes(checkbox.value);
    });

    if (hasTriggerCondition) {
      this.warningTarget.classList.remove('d-none');
    } else {
      this.warningTarget.classList.add('d-none');
    }
  }
}

